





































import Vue from 'vue';
import AOS from 'aos';
import LazyHydrate from 'vue-lazy-hydration';
import Header from '~/components/global/Header/Header.vue';
import 'aos/dist/aos.css';

export default Vue.extend({
  name: 'MainPage',
  components: {
    Header,
    Footer: () => import('@/components/global/Footer/Footer.vue'),
    MainPageBanner: () => import('./page-sections/MainPageBanner.vue'),
    MainPageJobs: () => import('./page-sections/MainPageJobs.vue'),
    MainPageTools: () => import('./page-sections/MainPageTools.vue'),
    MainPageCommunity: () => import('./page-sections/MainPageCommunity.vue'),
    MainPagePortfolio: () => import('./page-sections/MainPagePortfolio.vue'),
    MainPageAcademy: () => import('./page-sections/MainPageAcademy.vue'),
    MainPageTestimonials: () => import('./page-sections/MainPageTestimonials.vue'),
    MainPageCompanies: () => import('./page-sections/MainPageCompanies.vue'),
    MainPageApp: () => import('./page-sections/MainPageApp.vue'),
    MainPageSubscribe: () => import('./page-sections/MainPageSubscribe.vue'),
    LazyHydrate,
  },
  computed: {
    isMobile(): boolean {
      return !this.$breakpoint.smAndUp;
    },
  },
  mounted() {
    AOS.init();
  },
  methods: {
    async onSignUpClick(buttonLocation: string) {
      this.$analytics.logEvent('war-room__landing__cta-button__click', {
        button_location: buttonLocation,
      });

      if (this.$auth.loggedIn) {
        await this.$api.$post('/api/pages/war_room/welcome/apply_for_war_room.json', {});
        await this.$auth.fetchUser();

        await this.$utils.routeReplaceWithQuery(this.$pages.ONBOARDING_V3_PAGE);

        return;
      }

      this.$modal.showWithRoute('WAR_ROOM_SIGN_UP_MODAL');
    },
  },
});
